import { band, Col, motion, useSwipeAway, useTheme } from "@rally/ui-kit";
import { useEffect, useState } from "react";

export function Swipe({
  onDismiss,
  testID,
  zIndex = 20,
  children,
}: {
  onDismiss: () => void;
  testID?: string;
  zIndex?: number;
  children: React.ReactNode;
}) {
  const theme = useTheme();
  const [arrived, setArrived] = useState(theme.preferReduced);
  useEffect(() => {
    if (theme.preferReduced) return;
    const frame = requestAnimationFrame(() => setArrived(true));
    return () => cancelAnimationFrame(frame);
  }, [theme.preferReduced]);
  const { drag, handlers } = useSwipeAway(onDismiss);
  return (
    <Col
      testID={testID}
      {...handlers}
      style={
        {
          position: "fixed",
          top: band.heightNarrow,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex,
          transform: `translateX(${drag > 0 ? `${drag}px` : arrived ? "0" : "100%"})`,
          ...(theme.preferReduced || drag > 0
            ? {}
            : {
                transitionProperty: "transform",
                transitionDuration: `${motion.drawer.duration}ms`,
                transitionTimingFunction: motion.drawer.easing,
              }),
        } as object
      }
    >
      <Col
        testID={testID ? `${testID}-panel` : undefined}
        style={{
          flex: 1,
          overflow: "hidden",
          backgroundColor: theme.color["bg.surface"],
          borderLeftWidth: 1,
          borderLeftColor: theme.color["border.default"],
        }}
      >
        {children}
      </Col>
    </Col>
  );
}
